// Generated by scripts/fetch-ksc-imagery.mjs. Do not edit by hand.
// Bounds in degrees of each ground data level around the Kennedy launch site;
// maskSize is the mask PNG's width and height, range the distance (m) at the
// ends of its square-root distance code. Levels written this run: region.
export const KSC_LEVELS = {
  "near": {
    "lonMin": -80.68595872985091,
    "lonMax": -80.5222412701491,
    "latMin": 28.526441270149093,
    "latMax": 28.690158729850907,
    "maskSize": 2048,
    "range": 2500,
    "imagery": true
  },
  "far": {
    "lonMin": -81.3541,
    "lonMax": -80.1041,
    "latMin": 27.9833,
    "latMax": 29.2333,
    "maskSize": 2048,
    "range": 12000,
    "imagery": true
  },
  "region": {
    "lonMin": -92.25,
    "lonMax": -72,
    "latMin": 18,
    "latMax": 38.25,
    "maskSize": 2048,
    "range": 150000,
    "imagery": false
  }
};
